import { styled } from '@mui/material/styles'
import { DialogTitle, TextField } from '@mui/material'

const AutocompleteTextField = styled(TextField)(({ theme }) => ({
  position: 'relative',
  '& .MuiInputLabel-root': {
    top: 0, // Adjust this if necessary
    left: 8, // Adjust this if necessary
  },
  '& .MuiInputBase-root': {
    paddingRight: '40px', // Ensure space for the icon
  },
  '& .MuiAutocomplete-popupIndicator': {
    position: 'absolute',
    right: 8,
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.text.primary,
  },
}))

const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  textTransform: 'uppercase',
  fontWeight: 'bold',
}))

export { CustomDialogTitle, AutocompleteTextField }
